<template>
  <div
    :class="{
      'cms': cmsEnabled,
      'cms--changes-visible': showChanges,
    }"
  >
    <slot />
  </div>
</template>

<script>
import withResources from '../mixins/with-resources'

export default {
  mixins: [ withResources ],
  computed: {
    cmsEnabled () {
      return !!this.$cms
    },
    showChanges () {
      return this.$cms && this.$cms.showChanges
    }
  },
  mounted () {
    this.listen()
    this.frontendInitializedMessage()
  },
  beforeDestroy () {
    this.unlisten()
  }
}
</script>
